declare var SimpleBar;

namespace AgerLMS.WebSite {

    export interface ItemPageWidgetRequest {
    }

    @Serenity.Decorators.registerClass()
    export class ItemPageWidget extends Serenity.Widget<ItemPageWidgetRequest> {

        constructor(element: JQuery, opt: ItemPageWidgetRequest) {
            super(element, opt);

            let q = decodeURI(window.location.search).replace('?', '').split('&').map(param => param.split('=')).reduce((values, [ key, value ]) => {
              values[ key ] = value
              return values
            }, {});

            if (q["tabs"] != void 0) window.setTimeout(()=>  $("a#" + q["tabs"] + "-tab").click(), 100)
        }
    }
}